<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_2577_1683)">
    <path d="M7.99998 1.33331C4.31998 1.33331 1.33331 4.31998 1.33331 7.99998C1.33331 11.68 4.31998 14.6666 7.99998 14.6666C11.68 14.6666 14.6666 11.68 14.6666 7.99998C14.6666 4.31998 11.68 1.33331 7.99998 1.33331ZM8.66665 11.3333H7.33331V7.33331H8.66665V11.3333ZM8.66665 5.99998H7.33331V4.66665H8.66665V5.99998Z" fill="#323232"/>
  </g>
  <defs>
    <clipPath id="clip0_2577_1683">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>